import IS_ANDROID from './android.js';

const isDateSupported = () => {
  // hack:
  // Old browsers/safari will allow user to write text on dates,
  // we check for support and add a prop we will use in date conditions
  let supported = true;
  const b = document.body;
  const dateChecker = document.createElement('input');

  dateChecker.setAttribute('id', 'dateChecker');
  dateChecker.setAttribute('type', 'date');
  dateChecker.setAttribute('style', 'display:none');
  b.appendChild(dateChecker);
  dateChecker.setAttribute('value', 'any weird dummy non-date text');

  // new browsers will not accept the weird text, leaving field empty
  // but some browsers as Safari will return the weird text as value
  // we force weird text value browsers to be unsupported
  // Android unsupported as well due to hard to understand native UI
  if (dateChecker.value !== '' || IS_ANDROID) {
    supported = false;
  }

  b.removeChild(dateChecker);
  return supported;
};

const IS_DATE_SUPPORTED = isDateSupported();
export default IS_DATE_SUPPORTED;
